module.exports = __webpack_public_path__ + "img/noNetwork.b0d7a331.png";